var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1079 46.1562H27.7329C26.2404 46.1562 24.8098 46.7487 23.7542 47.8044C22.7004 48.8581 22.1079 50.2888 22.1079 51.7812V63.0312H97.1079V46.1562Z",
    fill: "#BFC5CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1079 53.0674H97.1079V56.5605H22.1079V53.0674Z",
    fill: "#BFC5CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1081 44.4296C97.1081 42.939 96.5156 41.5084 95.46 40.4528C94.4044 39.399 92.9737 38.8046 91.4831 38.8046C84.7687 38.8046 73.7081 38.8046 67.7869 38.8046C65.3737 38.8046 63.2306 40.344 62.4581 42.6296C61.3744 45.8415 60 49.9065 60 49.9065H97.1081V44.4296Z",
    fill: "#87909C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.773 64.1881C102.111 62.0244 101.484 59.8194 100.059 58.1544C98.6343 56.4894 96.553 55.5312 94.3611 55.5312C77.8218 55.5312 42.178 55.5312 25.6386 55.5312C23.4468 55.5312 21.3655 56.4894 19.9405 58.1544C18.5155 59.8194 17.8893 62.0244 18.2268 64.1881C20.1355 76.3981 23.5705 98.3844 25.258 109.188C25.8299 112.841 28.9743 115.531 32.6699 115.531H87.3299C91.0255 115.531 94.1699 112.841 94.7418 109.188C96.4293 98.3844 99.8643 76.3981 101.773 64.1881Z",
    fill: "#D2D6DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2268 64.1881L19.1886 70.3381C18.8493 68.1725 19.5936 65.9675 21.0186 64.3025C22.4436 62.6375 24.5249 61.6794 26.7168 61.6794H93.283C95.4749 61.6794 97.5561 62.6375 98.9811 64.3025C100.406 65.9675 101.151 68.1725 100.811 70.3381L101.773 64.1881C102.111 62.0244 101.484 59.8194 100.059 58.1544C98.6343 56.4894 96.553 55.5312 94.3611 55.5312C77.8218 55.5312 42.178 55.5312 25.6386 55.5312C23.4468 55.5312 21.3655 56.4894 19.9405 58.1544C18.5155 59.8194 17.8893 62.0244 18.2268 64.1881Z",
    fill: "#E4E8EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7158 100.244C55.7158 98.1741 54.0377 96.4941 51.9658 96.4941C47.8052 96.4941 41.1283 96.4941 36.9658 96.4941C34.8958 96.4941 33.2158 98.1741 33.2158 100.244V103.994C33.2158 106.066 34.8958 107.744 36.9658 107.744H51.9658C54.0377 107.744 55.7158 106.066 55.7158 103.994C55.7158 102.789 55.7158 101.452 55.7158 100.244Z",
    fill: "#FCFCFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.169 48.4237C44.0865 47.8949 44.0471 47.3737 44.049 46.8599C44.0528 45.8268 43.2165 44.9831 42.1815 44.9774C41.1465 44.9737 40.3028 45.8099 40.299 46.8449C40.2953 47.5537 40.3496 48.2756 40.4659 49.0068C40.6253 50.0287 41.5871 50.7281 42.609 50.5668C43.6309 50.4074 44.3303 49.4456 44.169 48.4237Z",
    fill: "#E4E8EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1377 41.2368C46.5052 40.8056 46.9177 40.4006 47.3752 40.0218C48.1721 39.3618 48.2846 38.1806 47.6246 37.3818C46.9646 36.5849 45.7834 36.4724 44.9846 37.1324C44.3565 37.6518 43.7884 38.2124 43.2821 38.8049C42.6109 39.5943 42.7065 40.7774 43.494 41.4487C44.2815 42.1199 45.4665 42.0243 46.1377 41.2368Z",
    fill: "#E4E8EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2045 37.3165C53.962 37.1459 54.7608 37.0184 55.5989 36.934C56.6283 36.8309 57.3802 35.9122 57.277 34.8828C57.1739 33.8534 56.2552 33.0997 55.2258 33.2028C54.232 33.3022 53.2833 33.4559 52.3833 33.6584C51.3727 33.8853 50.737 34.8884 50.9639 35.8972C51.1908 36.9078 52.1939 37.5434 53.2045 37.3165Z",
    fill: "#E4E8EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8024 36.9257C63.9462 36.9557 65.0318 36.9463 66.0668 36.9032C67.0999 36.8601 67.9043 35.9844 67.8612 34.9513C67.8181 33.9182 66.9443 33.1138 65.9093 33.1569C64.955 33.1963 63.9518 33.2038 62.8981 33.1776C61.8631 33.1513 61.0024 33.9707 60.9762 35.0038C60.9499 36.0388 61.7693 36.8994 62.8024 36.9257Z",
    fill: "#E4E8EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8145 35.728C75.0239 35.3774 76.1151 34.9593 77.0939 34.4905C78.0258 34.0424 78.4195 32.9211 77.9714 31.9874C77.5233 31.0555 76.402 30.6618 75.4701 31.1099C74.6639 31.4961 73.7658 31.8374 72.7683 32.128C71.7745 32.4168 71.2026 33.4574 71.4914 34.4511C71.7801 35.4449 72.8208 36.0168 73.8145 35.728Z",
    fill: "#E4E8EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.7284 29.8855C83.6246 28.6068 84.2096 27.2437 84.5321 25.8655C84.7684 24.8568 84.1402 23.848 83.1334 23.6118C82.1265 23.3774 81.1159 24.0037 80.8815 25.0105C80.6621 25.9443 80.2646 26.8668 79.6571 27.733C79.0646 28.5805 79.269 29.7505 80.1165 30.3449C80.964 30.9393 82.1359 30.733 82.7284 29.8855Z",
    fill: "#E4E8EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8401 18.343C83.0095 16.4062 81.7083 14.7749 80.1633 13.7099C79.3101 13.1212 78.142 13.3368 77.5551 14.188C76.9664 15.0393 77.182 16.2093 78.0333 16.7962C79.0364 17.488 79.8558 18.5662 80.3939 19.8224C80.8026 20.7749 81.907 21.2155 82.8576 20.8068C83.8083 20.398 84.2489 19.2955 83.8401 18.343Z",
    fill: "#E4E8EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7954 12.8078C61.8242 1.31963 79.406 2.06213 69.1704 12.8078H59.7954Z",
    fill: "#D2D6DC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7954 15.7178C61.8242 27.204 79.406 26.4634 69.1704 15.7178H59.7954Z",
    fill: "#D2D6DC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.627 16.1562H72.182C73.217 16.1562 74.057 15.3163 74.057 14.2812C74.057 13.2463 73.217 12.4062 72.182 12.4062H59.627C58.5938 12.4062 57.752 13.2463 57.752 14.2812C57.752 15.3163 58.5938 16.1562 59.627 16.1562Z",
    fill: "#E4E8EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFolder);
export default __webpack_public_path__ + "static/media/NoDataFolder.89516a54443e3380608970517300aac1.svg";
export { ForwardRef as ReactComponent };